import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationToast = _resolveComponent("NotificationToast")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NotificationToast),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentHeaderComponent))),
    _createVNode(_component_router_view),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentFooterComponent)))
  ]))
}